import {
  OpenClassCertificateType,
  OpenClassRegistration,
} from '../types/OpenClass';
import { attendedAllSessions } from './attendance';

type CertificateRegistration = Pick<
  OpenClassRegistration,
  | 'besaccCertificateFileName'
  | 'certificateType'
  | 'certificateResultStatus'
  | 'sessionAttendances'
>;

export const usesUploadedCertificate = (
  certificateType: OpenClassCertificateType,
): boolean => certificateType === 'besacc' || certificateType === 'ipaf';

export const certificateIssued = (
  registration: Pick<
    OpenClassRegistration,
    'attestNumber' | 'certificateSentAt'
  >,
): boolean =>
  registration.attestNumber != null || registration.certificateSentAt != null;

export const registrationHasRecordedOutcome = (
  registration: Pick<
    OpenClassRegistration,
    | 'attestNumber'
    | 'certificateResultStatus'
    | 'certificateSentAt'
    | 'sessionAttendances'
  >,
): boolean =>
  certificateIssued(registration) ||
  registration.certificateResultStatus !== 'not_recorded' ||
  (registration.sessionAttendances ?? []).some(
    (attendance) =>
      attendance.attendanceStatus !== 'not_recorded' ||
      attendance.result !== 'not_recorded',
  );

// Kept in step with the backend rule of the same name
export const passedOpenClass = (
  registration: CertificateRegistration,
): boolean => registration.certificateResultStatus === 'passed';

export const earnsFurboAttendanceAttest = (
  registration: CertificateRegistration,
): boolean =>
  registration.certificateType === 'furbo' &&
  registration.certificateResultStatus === 'failed' &&
  attendedAllSessions(registration.sessionAttendances ?? []);

export const canIssueCertificate = (
  registration: CertificateRegistration,
): boolean =>
  usesUploadedCertificate(registration.certificateType)
    ? passedOpenClass(registration) &&
      Boolean(registration.besaccCertificateFileName)
    : passedOpenClass(registration) || earnsFurboAttendanceAttest(registration);

// The backend emails the attendee, or their order's contact when the attendee has no address
export const lacksCertificateEmailRecipient = (
  registration: Pick<OpenClassRegistration, 'attendee' | 'orderHasContact'>,
): boolean =>
  !registration.attendee.email?.trim() &&
  registration.orderHasContact === false;
